<template>
  <div id="contenedor-main-contrato-diario-actividades">
    <div class="d-flex justify-space-between">
      <div
        style="width: 100%; overflow-x: auto; white-space: nowrap;">
        <v-row>
          <template v-for="frente in getContratoFrentes">
            <template>
              <v-col :key="frente.id" cols="4">
                <CardFrente
                :soloLectura="soloLectura"
                :frente="frente" />
              </v-col>
            </template>
          </template>
        </v-row>
      </div>
    </div>
    <!-- Registrar nueva actividad -->
    <v-dialog
        v-if="frenteActividad"
        v-model="mostrarRegistrarActividad"
        width="800"
        persistent>
        <registrar-actividad
          :id-contrato="$route.params.idContrato"
          :frente="frenteActividad"
          :id-frente="frenteActividad.id"
          v-on:cerrar="cerrarVentana">
        </registrar-actividad>
      </v-dialog>
      <!-- Editar actividad -->
      <v-dialog
        v-if="estaActividad"
        v-model="mostrarEditarActividad"
        width="800"
        persistent>
        <editar-actividad
          :actividadContratoEditar="estaActividad"
          v-on:cerrar="cerrarVentana">
        </editar-actividad>
      </v-dialog>
      <!-- Eliminar Actividad -->
      <v-dialog
      v-if="estaActividad"
      v-model="mostrarEliminarActividad"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
        <eliminar-actividad
          :contratoActividadEliminar="estaActividad"
          v-on:cerrar="cerrarVentana"
        />
    </v-dialog>
    <v-dialog
      v-model="mostrarCarrucelImagenes"
      width="700">
      <v-card>
        <v-card-text>
          <imagen-carousels
            :imagenes="imagenes"
            v-on:cerrar="mostrarCarrucelImagenes = !mostrarCarrucelImagenes">
          </imagen-carousels>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_FRENTES from '@/graphql/querys/administracion/contratos/contrato/frentes/contratoFrentes.gql';
import RegistrarActividad from '@/components/administracion/contratos/contrato/diarioactividades/Agregar.vue';
import EditarActividad from '@/components/administracion/contratos/contrato/diarioactividades/Editar.vue';
import EliminarActividad from '@/components/administracion/contratos/contrato/diarioactividades/Eliminar.vue';
import eventBus from '@/helpers/eventBus';
import ImagenCarousels from './ImagenCarousels.vue';
import CardFrente from './CardFrente.vue';

export default {
  name: 'ContratistaMainDiarioActividades',
  props: {
    soloLectura: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      idContrato: this.$route.params.idContrato,
      mostrarRegistrarActividad: false,
      mostrarEditarActividad: false,
      mostrarEliminarActividad: false,
      mostrarCarrucelImagenes: false,
      estaActividad: null,
      frenteActividad: null,
      imagenes: [],
    };
  },
  components: {
    RegistrarActividad,
    EditarActividad,
    EliminarActividad,
    ImagenCarousels,
    CardFrente,
  },
  apollo: {
    contratoFrentes: {
      query: CONTRATO_FRENTES,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  computed: {
    getContratoFrentes() {
      if (!this.contratoFrentes) return [];
      return [...this.contratoFrentes].sort((a, b) => a.orden - b.orden);
    },
  },
  methods: {
    cerrarVentana() {
      this.mostrarRegistrarActividad = false;
      this.mostrarEditarActividad = false;
      this.mostrarEliminarActividad = false;
      this.estaActividad = null;
      this.frenteActividad = 0;
    },
  },
  mounted() {
    eventBus.$on('mostrar-imagenes-actividad-contrato', (imagenes) => {
      this.imagenes = imagenes;
      this.mostrarCarrucelImagenes = true;
    });
    eventBus.$on('registrar-actividad-contrato', (frente) => {
      this.frenteActividad = frente;
      this.mostrarRegistrarActividad = true;
    });
    eventBus.$on('editar-actividad-contrato', (actividadContrato) => {
      this.estaActividad = actividadContrato;
      this.mostrarEditarActividad = true;
    });
    eventBus.$on('eliminar-actividad-contrato', (actividadContrato) => {
      this.estaActividad = actividadContrato;
      this.mostrarEliminarActividad = true;
    });
  },
};
</script>

<style lang="scss">
.disabled-card {
  border: dotted 1px #ccc;
}
.inline-block {
  display: inline-block;
}
</style>
